import React from 'react';
import _ from 'lodash';
import Helmet from 'react-helmet';
import AccountReorderActions from '../../actions/AccountReorderActions';
import InternetBankingActions from '../../actions/InternetBankingActions';
import SavingPotsActionCreator from '../../actions/SavingPotsActionCreator';
import AccountsActionCreator from '../../actions/SavingPotsActionCreator';
import StatementsPreferencesStore from '../../stores/StatementsPreferencesStore';
import SavingsPotsStore from '../../stores/SavingsPotsStore';
import AccountsStore from '../../stores/AccountsStore';
import AccountReorderStore from '../../stores/AccountReorderStore';

import AccountPreferenceCards from './AccountPreferenceCards';
import LoaderComponent from '../common/LoaderComponent';
import AccountReorderParser from '../../parsers/AccountReorderParser';
import { RequiresAuthenticatedUser } from '../RequiresAuthenticatedUser';

import PropTypes from 'prop-types';
import { HighlightTile } from 'web-ui-components/lib/molecules/tile';
import FavouritesStore from '../../stores/AccountsStore/FavouritesStore';
import FavouritesActionCreator from '../../actions/AccountsActionCreator/FavouritesActionCreator';
import { BioCatchContext } from '../BioCatchContext';
import { DIGITAL_SERVICING_CONTEXT } from '../../config/BioCatch';

let accountList = [];
let accountListErrorFlag = false;
let accountListLoaderFlag = true;
let dynamicTextForAccessibility = '';

class AccountPreference extends React.Component {
  constructor(props) {
    super(props);
    this.onStoreChange = this.onStoreChange.bind(this);
    this.getAccountList = this.getAccountList.bind(this);
    this.upButtonClick = this.upButtonClick.bind(this);
    this.downButtonClick = this.downButtonClick.bind(this);
    this.onCancelClick = this.onCancelClick.bind(this);
    this.sendRequestPacket = this.sendRequestPacket.bind(this);
    this.onBackClickConfirmation = this.onBackClickConfirmation.bind(this);
    this.checkIfChanged = this.checkIfChanged.bind(this);
    this.state = {
      accountListError: accountListErrorFlag,
      load: accountListLoaderFlag,
      requestPacket: null,
      confirmReorderButton: true,
      favouritesLoading: false,
    };
  }

  componentWillMount() {
    if (FavouritesStore.isLargeCustomer()) {
      FavouritesStore.addChangeListener(this.onStoreChange);
      FavouritesActionCreator.getFavouriteAccounts();
    }
    AccountsStore.addChangeListener(this.onStoreChange);
    AccountReorderStore.addChangeListener(this.onStoreChange);
    accountList = _.cloneDeep(AccountsStore.getAll());
    accountList = _.sortBy(accountList, ['display_order']);
    this.setState({
      accountListError: accountListErrorFlag,
      load: accountListLoaderFlag,
    });
  }

  componentWillUnmount() {
    accountList = [];
    accountListErrorFlag = false;
    accountListLoaderFlag = true;
    AccountsStore.removeChangeListener(this.onStoreChange);
    AccountReorderStore.removeChangeListener(this.onStoreChange);
    if (FavouritesStore.isLargeCustomer()) {
      FavouritesStore.removeChangeListener(this.onStoreChange);
    }
  }

  onBackClickConfirmation(e) {
    e.preventDefault();
    const urlString = StatementsPreferencesStore.getBackPageReference();
    SavingsPotsStore.getMoveMoneyAccountIndex();
    SavingPotsActionCreator.saveNavigationReference(urlString);
    urlString !== '' && InternetBankingActions.navigateToWebTask(urlString);
  }

  onCancelClick() {
    dynamicTextForAccessibility = '';
    accountList = _.cloneDeep(AccountsStore.getAll());
    this.setState({
      confirmReorderButton: true,
    });
  }

  onStoreChange() {
    accountListErrorFlag =
      AccountReorderParser.accountListErrorFlag() ||
      AccountsStore.getAccountReorderErrorFlag();
    accountListLoaderFlag = AccountReorderParser.accountListLoaderFlag();
    if (accountListLoaderFlag) {
      if (!accountListErrorFlag) {
        if (!AccountsStore.getAccountReorderErrorFlag()) {
          accountList = [];
          accountList = _.cloneDeep(AccountsStore.getAll());
        }
      }
    }
    accountList = _.sortBy(accountList, ['display_order']);
    if (FavouritesStore.isLargeCustomer()) {
      const { loading } = FavouritesStore.getUIState();
      this.setState({ favouritesLoading: loading });
    }
    this.setState({
      accountListError: accountListErrorFlag,
      load: accountListLoaderFlag,
      confirmReorderButton: true,
    });
  }

  getAccountList() {
    let displayAccountList = _.sortBy(accountList, ['display_order']).map(
      (cardDetails) => {
        let upReorderButton = false;
        let downReorderButton = false;
        cardDetails.display_order === 1
          ? (upReorderButton = true)
          : (upReorderButton = false);
        cardDetails.display_order === accountList.length
          ? (downReorderButton = true)
          : (downReorderButton = false);
        return (
          <div key={cardDetails.id}>
            <AccountPreferenceCards
              cardDetails={cardDetails}
              upReorderButton={upReorderButton}
              downReorderButton={downReorderButton}
              upButtonClick={this.upButtonClick}
              downButtonClick={this.downButtonClick}
            />{' '}
          </div>
        );
      }
    );
    return (
      <ol
        className="u-no-padding"
        aria-labelledby="page-preferences-order-heading"
      >
        {displayAccountList}
      </ol>
    );
  }

  checkIfChanged() {
    let orderChangeFlag = false;
    _.map(accountList, (updatedData) => {
      const orderChanged = AccountsStore.getAccountDetail(updatedData.id);
      if (orderChanged.display_order !== updatedData.display_order) {
        orderChangeFlag = true;
      }
    });

    accountList = _.sortBy(accountList, ['display_order']);

    if (orderChangeFlag) {
      this.setState({
        confirmReorderButton: false,
      });
    } else {
      this.setState({
        confirmReorderButton: true,
      });
    }
  }

  downButtonClick(id) {
    const changedIndex = _.findIndex(accountList, { id });
    const belowAccountDisplayOrder =
      accountList[changedIndex + 1].display_order;
    const selectedAccountDisplayOrder = accountList[changedIndex].display_order;
    accountList[changedIndex].display_order = belowAccountDisplayOrder;
    accountList[changedIndex + 1].display_order = selectedAccountDisplayOrder;
    dynamicTextForAccessibility = ` ${accountList[changedIndex].displayName} is now ${belowAccountDisplayOrder} of ${accountList.length}`;

    this.checkIfChanged();
  }

  retryServices() {
    AccountsActionCreator.getAccountsList();
  }

  sendRequestPacket() {
    this.setState({ load: false });
    AccountReorderActions.setAccountOrderChanges(accountList);
  }

  upButtonClick(id) {
    const changedIndex = _.findIndex(accountList, { id });
    const upperAccountDisplayOrder =
      accountList[changedIndex - 1].display_order;
    const selectedAccountDisplayOrder = accountList[changedIndex].display_order;
    accountList[changedIndex].display_order = upperAccountDisplayOrder;
    accountList[changedIndex - 1].display_order = selectedAccountDisplayOrder;
    dynamicTextForAccessibility = ` ${accountList[changedIndex].displayName} is now ${upperAccountDisplayOrder} of ${accountList.length}`;

    this.checkIfChanged();
  }

  render() {
    const { favouritesLoading, load } = this.state;
    let pageToBeDisplayed;
    if (!this.state.accountListError) {
      pageToBeDisplayed = (
        <div className="change-account-order-page">
          <div className="col-md1-24">
            <div className="c-step-header">
              <p className="c-step-header__crumbs">
                <a
                  className="c-step-header__link"
                  href=""
                  onClick={this.onBackClickConfirmation}
                >
                  <span className="icon icon-page-back c-step-header__linkicon" />
                  <span className="c-step-header__linktext">
                    {StatementsPreferencesStore.getBackPageReference() ===
                    'WEB-HOMEPAGE'
                      ? this.props.content.backToAccounts
                      : this.props.content.back}
                  </span>
                </a>
              </p>
              <h2
                className="c-step-header__title"
                id="page-preferences-order-heading"
              >
                {this.props.content.accountReorderHeader}
              </h2>
            </div>

            <p>
              {FavouritesStore.isLargeCustomer()
                ? this.props.content.accountReorderFavouritesHeader
                : this.props.content.accountReorderHeader1}
            </p>
            {accountList.length > 1 && (
              <p>
                <strong>{this.props.content.arrowButtonsUseTip}</strong>
              </p>
            )}
            <div className="u-visually-hidden" aria-live="polite" role="status">
              {' '}
              {dynamicTextForAccessibility}{' '}
            </div>
            {favouritesLoading || !load ? (
              <LoaderComponent type={'large'} />
            ) : (
              this.getAccountList()
            )}

            {accountList.length > 0 && (
              <div className="form-actions">
                <a
                  href=""
                  className="c-btn c-btn--secondary"
                  onClick={this.onBackClickConfirmation}
                >
                  <svg
                    width="96"
                    height="96"
                    viewBox="0 0 96 96"
                    xmlns="http://www.w3.org/2000/svg"
                    className="css-17x9ah1"
                  >
                    <path d="M62.862 48L22.508 8.587a4.972 4.972 0 0 1 0-7.114l.148-.144a5 5 0 0 1 6.988 0l43.848 42.826A4.96 4.96 0 0 1 74.982 48a4.959 4.959 0 0 1-1.49 3.845L29.644 94.671a5 5 0 0 1-6.988 0l-.148-.144a4.972 4.972 0 0 1 0-7.114L62.862 48z" />
                  </svg>
                  {StatementsPreferencesStore.getBackPageReference() ===
                  'WEB-HOMEPAGE'
                    ? this.props.content.backToAccounts
                    : this.props.content.back}
                </a>
                <button
                  type="submit"
                  className="c-btn c-btn--secondary"
                  disabled={this.state.confirmReorderButton}
                  onClick={this.onCancelClick}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="c-btn c-btn--default"
                  disabled={this.state.confirmReorderButton}
                  onClick={this.sendRequestPacket}
                >
                  Confirm changes
                </button>
              </div>
            )}
            {accountList.length === 0 && FavouritesStore.isLargeCustomer() && (
              <div className="web-ui-components">
                <HighlightTile type="info">
                  {this.props.content.accountReorderAddFavourites}
                </HighlightTile>
              </div>
            )}
          </div>
        </div>
      );
    } else {
      pageToBeDisplayed = (
        <div className="change-account-order-page">
          <div className="col-md1-24">
            <div className="c-step-header">
              <p className="c-step-header__crumbs">
                <a
                  className="c-step-header__link"
                  href=""
                  onClick={this.onBackClickConfirmation}
                >
                  <span className="icon icon-page-back c-step-header__linkicon" />
                  <span className="c-step-header__linktext">
                    {StatementsPreferencesStore.getBackPageReference() ===
                    'WEB-HOMEPAGE'
                      ? this.props.content.backToAccounts
                      : this.props.content.back}
                  </span>
                </a>
              </p>
              <h2
                className="c-step-header__title"
                id="page-preferences-order-heading"
              >
                {this.props.content.accountReorderHeader}
              </h2>
            </div>

            <p>
              <strong>Sorry, there's been a technical problem</strong>
            </p>

            <p>
              It looks like something has gone wrong in the background. Please
              try again.
            </p>

            <p>If you're still having problems, please get in touch.</p>

            <div className="form-actions">
              <a
                href=""
                className="c-btn c-btn--secondary"
                onClick={this.onBackClickConfirmation}
              >
                Back
              </a>
              <button
                type="submit"
                className="c-btn c-btn--default"
                onClick={this.sendRequestPacket}
              >
                Retry
              </button>
            </div>
          </div>
        </div>
      );
    }

    return (
      <BioCatchContext context={DIGITAL_SERVICING_CONTEXT}>
        <div>
          <div id="site-main" className="page bow" role="main" tabIndex="-1">
            <Helmet title="Accounts" />
            <div className="container" id="site-main-container">
              <div className="row">{pageToBeDisplayed}</div>
            </div>
          </div>
        </div>
      </BioCatchContext>
    );
  }
}

AccountPreference.propTypes = {
  content: PropTypes.object,
};

export default RequiresAuthenticatedUser(AccountPreference);
